<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'familymembers.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <local-grid name="personsGrid" :preload="preload" height="calc(100vh - 250px)" :editable="true" v-bind:url="url" v-bind:columns="columns" :pageable='false' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></local-grid>
  </b-card>
</div>
</template>

<script>
import LocalGrid from '@/components/LocalGrid.vue'
import router from '@/router'

export default {
  name: 'FamiliesGrid',
  components: {
    LocalGrid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date',
          editable: false
        },
        'id': {
          type: 'number',
          editable: false
        },
        'compound_key': {
          type: 'text',
          editable: false
        },
        'family_id': {
          type: 'text',
          editable: false
        },
        'family_surname': {
          type: 'text',
          editable: false
        },
        'code': {
          type: 'number',
          editable: false
        }
      },
      url: 'familymembers',
      preload: [{
        api: 'familymembertypes/lst',
        field: 'family_member_type_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '120px'
      },
      {
        field: 'code',
        title: 'Código',
        width: '120px'
      },
      {
        field: 'compound_key',
        title: 'Chave composta',
        width: '120px'
      },
      {
        field: 'family_member_type_id',
        title: 'Escalão',
        values: [],
        width: '120px'
      },
      {
        field: 'family_id',
        title: 'ID Família',
        width: '120px'
      },
      {
        field: 'family_surname',
        title: 'Apelido',
        width: '180px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '180px'
      },
      {
        field: 'phone',
        title: 'Telefone',
        width: '180px'
      },
      {
        field: 'email',
        title: 'Email',
        width: '180px'
      },
      {
        field: 'notes',
        title: 'Observações',
        width: '180px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('familymembers.edit')) {
        var route = router.resolve({
          name: 'familymembers.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('familymembers.view')) {
        var route = router.resolve({
          name: 'familymembers.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
